export function compareAgentLabels(a, b, options = {}) {
  const { lastLabel } = options;

  if (lastLabel) {
    if (a === lastLabel && b === lastLabel) return 0;
    if (a === lastLabel) return 1;
    if (b === lastLabel) return -1;
  }

  return String(a ?? "").localeCompare(String(b ?? ""));
}

export function compareCommissionContracts(a, b, selectors) {
  return (
    compareDates(selectors.signed(a), selectors.signed(b)) ||
    compareStrings(selectors.providerNumber(a), selectors.providerNumber(b)) ||
    compareStrings(selectors.contractNumber(a), selectors.contractNumber(b))
  );
}

function compareDates(a, b) {
  const timeA = getDateTime(a);
  const timeB = getDateTime(b);

  if (timeA !== timeB) return timeA - timeB;
  return 0;
}

function getDateTime(value) {
  if (!value) return 0;

  const time = new Date(value).getTime();
  return Number.isNaN(time) ? 0 : time;
}

function compareStrings(a, b) {
  return String(a ?? "").localeCompare(String(b ?? ""), undefined, {
    numeric: true,
  });
}